import { Controller } from "stimulus"

export default class extends Controller {
  toClipboard(e){
    e.preventDefault()
    navigator.clipboard.writeText(this.element.href)
    toastr.success(this.element.href, 'Copied to Clipboard')
  }
}
